import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { map } from "rxjs/operators";
import { AppSettings } from "../../../config/config";
import { apiConstants } from "../../constant/apiConstant";

export type SearchSecondaryFilter = 'ALL' | 'STUDENT' | 'STAFF';

// Legacy endpoint — returns a raw array, not this app's usual {status, body}
// wrapper. An empty/no-match result is just an empty array, not an error.
export interface SearchProfileRecord {
  userId: string;
  userType: 'STUDENT' | 'STAFF';
  userName: string | null;
  staffName: string | null;
  studentName: string | null;
  userImage: string | null;
  staffImage: string | null;
  studentImage: string | null;
  classNumber: string | null;
  classDivision: string | null;
  classId: string;
  designation: string | null;
}

@Injectable({ providedIn: 'root' })
export class StaffSearchService {
  // Unversioned endpoint — lives directly under the host root, not under
  // /api/v3 like most other staff endpoints.
  private url = AppSettings.API_ENDPOINT_STAFF_BASE;

  constructor(private http: HttpClient) {}

  searchProfile(searchContent: string, secondaryFilter: SearchSecondaryFilter, searchingByStaffId: number | string) {
    const body = {
      primaryFilter: 'SCHOOL',
      secondaryFilter,
      searchContent,
      searchingByStaffId: String(searchingByStaffId)
    };
    return this.http
      .post<SearchProfileRecord[]>(this.url + apiConstants.searchProfile, body)
      .pipe(map((res) => res || []));
  }
}
